export class WheelsBySpecsParamsModel {
  diameter: number;
  pcd: string;
  width: number;
  minOffset: number;
  maxOffset: number;
}
